const About = () => {
  return (
    <div
      style={{
        padding: "32px",
        fontWeight: "bold",
      }}
    >
      Hi My name is James Han I made this because I lovee Pokemon Haha
      <br />
      <br />
      <br />
      My Favorite pokemon games is Black and White
      <br />
      <br />
      <br />
      Follow me on insta:{" "}
      <a href="https://instagram.com/hamesjan" target="blank">
        hamesjan
      </a>
      <br />
      <br />
      <br />
      <br />
      <p>Email me: jjhan (at) ucsd (dot) edu</p>
    </div>
  );
};
export default About;
